import { useMemo } from 'react'
import { validateLatinCharacters } from '@/shared/lib/latinCharacterValidation'

export type AddressLatinFields = {
  street?: string
  street2?: string
  streetNumber?: string
  subDivision?: string
  postCode?: string
  poBox?: string
  city?: string
}

export type AddressLatinErrors = Partial<Record<keyof AddressLatinFields, string>>

export function useAddressLatinCharacterValidation(
  fields: AddressLatinFields,
  errorMessage: string,
  allowedSymbols?: string[]
): AddressLatinErrors {
  return useMemo(() => {
    const errors: AddressLatinErrors = {}
    for (const [fieldName, value] of Object.entries(fields)) {
      if (value !== undefined && value !== null) {
        const error = validateLatinCharacters(
          value,
          errorMessage,
          allowedSymbols
        )
        if (error) {
          errors[fieldName as keyof AddressLatinFields] = error
        }
      }
    }
    return errors
  }, [fields, errorMessage, allowedSymbols])
}
